import type { Contact } from 'bundles/backoffice/contacts/types';

export function getShareableAttributes(contact: Contact) {
  const attributes = [
    buildAttribute(contact.email, 'Email', 'email'),
    buildAttribute(contact.phoneFormatted, 'Phone', 'phone_numbers'),
    buildAttribute(contact.addressFormatted, 'Address', 'addresses'),
  ];

  if (contact.isPerson) {
    attributes.push(
      buildAttribute(getBusinessLabel(contact), 'Businesses', 'businesses'),
      buildAttribute(contact.jobTitle, 'Job Title', 'job_title'),
      buildAttribute(contact.licenseNumber, 'License Number', 'license_number'),
    );
  } else {
    attributes.push(buildAttribute(contact.website, 'Website', 'website'));
  }

  return attributes.filter(attribute => attribute !== undefined);
}

function getBusinessLabel(contact: Contact) {
  if (contact.businessRecords) {
    const business = contact.businessRecords[0]?.business;
    return business?.name || business?.email;
  }
}

function buildAttribute(value: string | null | undefined, label: string, key: string) {
  if (value) {
    return {
      label: `${label}: ${value}`,
      key,
    };
  }
}
